import { WebPlaySettings } from '@playbooks/web-play-component'

/**
 * If webPlay requires login than only parent page can get webPlay info (using authProxy)
 */
export default async function getWebPlayInfoFromParentPage() {
  return new Promise<WebPlaySettings | null>(resolve => {
    const info = window.webPlayInfo

    if (!info) {
      resolve(null)
      return
    }

    if (info.isLoading === true) {
      const interval = setInterval(() => {
        // As soon as the loading is done we get webPlayInfo and terminate
        // the interval and resolve the promise with the info
        if (window.webPlayInfo?.isLoading === undefined) {
          clearInterval(interval)

          resolve(window.webPlayInfo as unknown as WebPlaySettings)
        }
      }, 300)

      // Fallback in case the interval doesn't resolve so we need
      // to complete the promise after some time to avoid hanging
      setTimeout(() => {
        clearInterval(interval)
        resolve(null)
      }, 10000)
      return
    }

    resolve(info as unknown as WebPlaySettings)
  })
}
